import _ from 'lodash';
import UtilsService from '../../../services/utils.service';

export default class DashboardService {
  constructor(model) {
    var self = this;
    self.model = model;

    if (_.isNil(self.model)) {
      throw new Error('Model is undefined at DashboardService!');
    }
  }

  static newPanel(options) {
    var panel = _.cloneDeep(_.get(options, 'panel'));
    var params = _.cloneDeep(_.get(options, 'params', null));

    let cloneDeep = _.cloneDeep({
      id: UtilsService.generateID(),
      type: _.get(panel, 'type'),
      // options: params,
      params: {
        options: params
      },
      height: _.get(panel, 'height'),
      width: _.get(panel, 'width'),
      x: 32000,
      y: 32000,
      autoPosition: true
      // x: _.get(panel, 'x'),
      // y: _.get(panel, 'y')
    });
    if (cloneDeep.params.options.id) {
      cloneDeep.params.options.id = cloneDeep.id;
    }
    return cloneDeep;
  }

  //  TODO: add panel when user confirms creation
  //  TODO:  (do not wait until closes "add panel" modal)
  addPanel(options) {
    var self = this;
    var panels = self.model.getPanels();
    var panel = self.constructor.newPanel(options);
    panels.push(panel);
    self.model.setPanels(panels);
    return panel;
  }

  //  TODO: add panel when user confirms creation
  //  TODO:  (do not wait until closes "add panel" modal)
  addPanels(optionsSet) {
    var self = this;
    var panels = self.model.getPanels();
    var newPanels = [];
    if (!_.isEmpty(optionsSet)) {
      _.forEach(optionsSet, function(options) {
        var panel = self.constructor.newPanel(options);
        panels.push(panel);
        newPanels.push(panel);
      });
      self.model.setPanels(panels);
    }
    return newPanels;
  }

  updatePanelPositions(newPanels) {
    var self = this;
    return self.model.updatePanelPositions(newPanels);
  }

  updatePanelOptions(updatedOptions) {
    var self = this;
    return self.model.updatePanelOptions(updatedOptions);
  }

  getPanels() {
    var self = this;
    return self.model.getPanels();
  }

  removePanel(id) {
    var self = this;
    var panels = self.model.getPanels();
    var filteredPanels = _.filter(panels, function(p) { return p.id !== id; });
    self.model.setPanels(filteredPanels);
  }

  setPanels(panels) {
    var self = this;
    self.model.setPanels(panels);
  }
}
